module.exports = __webpack_public_path__ + "c13a9552846af805b4afcf1d2b3cfea7.fbx";